import { gql } from '@apollo/client';

export const GET_OPERATIONS_HIERARCHY = gql`
    query GetOperationsHierarchy($includeClosedStores: Boolean) {
        getOperationsHierarchy(includeClosedStores: $includeClosedStores) {
            opsAreas {
                id
                name
                divisions {
                    id
                    name
                    stores {
                        id
                        name
                        storeNo
                    }
                }
            }
        }
    }
`;
